'use strict';
const timeFilter = require('../../../../../utils/timestamp-util').timestampToDateFilter;

function parse(reader) {
    reader.readUInt8("version");
    reader.readUInt32LE("data.timestamp", timeFilter);
    reader.readBit(2, "data.din");
    reader.readBit(2, "data.dout");
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_3/digit/change-report-parser.js